import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIList } from "config/apiList";
import { baseUrl } from "config/defaultUrl";
import axios from "utils/axios";

export const getAllPoliciesThunk = createAsyncThunk("kyp/getAllPolicies", async () => {
  const response = await axios.get(baseUrl + `${APIList.allPolicies}`);
  return response.data;
});

export const getBenefitSummaryThunk = createAsyncThunk("kyp/getBenefitSummaryThunk", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getBenefitSummary}/${policyId}`);
  return response.data;
});

export const getHealthQualityThunk = createAsyncThunk("kyp/getHealthQualityThunk", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getHealthQuality}/${policyId}`);
  return response.data;
});

export const getHealthResultThunk = createAsyncThunk("kyp/getHealthResultThunk", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getHealthQualityResult}/${policyId}`);
  return response.data;
});
export const checkCouponThunk = createAsyncThunk("kyp/checkCouponThunk", async (payload: { coupon: string; policyId: string }) => {
  const response = await axios.get(baseUrl + `${APIList.couponCheck}/${payload.coupon}?src=KYP&policyId=${payload.policyId}`);
  return response.data;
});

export const transactionThunk = createAsyncThunk("kyp/transactionThunk", async (payload: any) => {
  const response = await axios.post(baseUrl + `${APIList.kypTransaction}`, payload);
  return response.data;
});

export const getSinglePolicy = createAsyncThunk("kyp/getSinglePolicy", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getSinglePolicy}/${policyId}`);
  return response.data;
});

export const postHealthQualityResultThunk = createAsyncThunk("kyp/postHealthQualityResultThunk", async (payload: any) => {
  const response = await axios.post(baseUrl + `${APIList.postHealthQualityResult}`, payload);
  return response.data;
});

export const uploadPolicyThunk = createAsyncThunk("kyp/uploadPolicyThunk", async (payload: any) => {
  const response = await axios.post(baseUrl + `${APIList.uploadPolicy}`, payload);
  return response.data;
});

export const getUserProfileThunk = createAsyncThunk("kyp/getUserProfileThunk", async () => {
  const response = await axios.get(baseUrl + `${APIList.getUserProfile}`);
  return response.data;
});

export const getPolicyDetailThunk = createAsyncThunk("kyp/getPolicyDetailThunk", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getPolicyDetails}${policyId}`);
  return response.data;
});

export const getQuestionsThunk = createAsyncThunk("kyp/getQuestionsThunk", async (payload: { policyId: string }) => {
  const response = await axios.post(baseUrl + `${APIList.getQuestions}`, payload);
  return response.data;
});
export const postQualityCheckThunk = createAsyncThunk("kyp/postQualityCheck", async (payload: { changeQuestionValues: any; policyId: string }) => {
  const response = await axios.post(baseUrl + `${APIList.postQualityCheck}`, payload);
  return response.data;
});

export const putPolicyData = createAsyncThunk("kyp/putPolicyData", async (payload: { policyId: any; body: any }) => {
  const response = await axios.put(baseUrl + `${APIList.policy}/${payload.policyId}`, payload.body);
  return response.data;
});

export const getLifeResult = createAsyncThunk("kyp/getLifeResult", async (payload: { policyId: string }) => {
  const response = await axios.post(baseUrl + `${APIList.lifeResult}`, payload);
  return response.data;
});

export const getMotorPreview = createAsyncThunk("kyp/getMotorPreview", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getMotorPreview}/${policyId}`);
  return response.data;
});

export const getMotorReviewData = createAsyncThunk("kyp/getMotorReviewData", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getMotorReviewData}/${policyId}`);
  return response.data;
});

export const submitReviewData = createAsyncThunk("kyp/submitReviewData", async (payload: { policyId: string; userInput: any }) => {
  const response = await axios.post(baseUrl + `${APIList.submitReviewData}`, payload);
  return response.data;
});

export const getMotorBenefitSummary = createAsyncThunk("kyp/getMotorBenefitSummary", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getMotorBenefitSummary}/${policyId}`);
  return response.data;
});

export const getMotorKypResult = createAsyncThunk("kyp/getMotorKypResult", async (policyId: string) => {
  const response = await axios.get(baseUrl + `${APIList.getMotorKypResult}/${policyId}`);
  return response.data;
});
